import {Button, Modal} from "react-bootstrap";
import {useState} from "react";
import HtvApi from "../../htv-api/HtvApi";
import {ErrorHandling} from "../../helpers/error-handling";
import Loader from "../../layouts/main/components/Loader";
import {GlobalState} from "../../state/GlobalState";

const VideoThumbnailResolutionDeleteDialogButton = ({thumbnailId, onDeleted}) => {
    const [modalState, setModelState] = useState({
        display: false,
        isLoading: true,
        thumbnailData: undefined,
    });

    const hideModal = () => {
        setModelState({display: false, isLoading: true, thumbnailData: undefined});
    };

    const confirmThumbnailDeletion = () => {
        setModelState({
            display: true,
            isLoading: true,
            thumbnailData: undefined,
        });
        HtvApi.VideoThumbnailResolutions.Get(thumbnailId)
            .then(response => {
                setModelState({
                    display: true,
                    isLoading: false,
                    thumbnailData: response,
                });
            })
            .catch((error) => {
                ErrorHandling.GlobalStateError(error);
                hideModal();
            });
    }

    const deleteThumbnail = () => {
        HtvApi.VideoThumbnailResolutions.Delete(thumbnailId)
            .then(() => GlobalState.setSuccess('Successful operation!', 'Thumbnail deleted!'))
            .catch(ErrorHandling.GlobalStateError)
            .then(() => {
                hideModal();
                onDeleted();
            });
    };

    const deleteButton = (
        <button type="button" className="btn btn-danger btn-sm" onClick={() => confirmThumbnailDeletion()}>
            <i className="far fa-trash-alt" /> Delete
        </button>
    );

    if (modalState.isLoading) {
        return (
            <>
                {deleteButton}
                <Modal
                    show={modalState.display}
                    onHide={() => hideModal()}
                    size="xl"
                    aria-labelledby="contained-modal-title-vcenter"
                    centered
                >
                    <Loader />
                    <Modal.Header closeButton>
                        <Modal.Title id="contained-modal-title-vcenter">Loading...</Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                    </Modal.Body>
                    <Modal.Footer>
                        <Button variant="secondary" onClick={() => hideModal()} className="mr-auto">
                            Close
                        </Button>
                    </Modal.Footer>
                </Modal>
            </>
        );
    }

    return (
        <>
            {deleteButton}
            <Modal
                show={modalState.display}
                onHide={() => hideModal()}
                size="xl"
                aria-labelledby="contained-modal-title-vcenter-delete"
                centered
            >
                <Modal.Header closeButton>
                    <Modal.Title id="contained-modal-title-vcenter-delete">Confirm video thumbnail deletion</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    Confirm deletion of video thumbnail with ID: {modalState.thumbnailData['id']}
                    <br />
                    {modalState.thumbnailData['width']} x {modalState.thumbnailData['height']}
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="secondary" onClick={() => hideModal()} className="mr-auto">
                        Close
                    </Button>
                    <Button variant="danger" onClick={() => deleteThumbnail()}>
                        DELETE THUMBNAIL (this is permanent!)
                    </Button>
                </Modal.Footer>
            </Modal>
        </>
    )
};

export default VideoThumbnailResolutionDeleteDialogButton;
